<template>
    <component :is="RedpacketComponent" :send-redpack="props.sendRedpack" :is-preview="props.isPreview" />
</template>

<script >
import { defineProps, onMounted } from 'vue-demi';
import { isPc } from '../../../../../utils';
import H5Packet from './H5.vue';
import PCPacket from './PC.vue';
const __sfc_main = {};
__sfc_main.props = ['sendRedpack', 'isPreview'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const RedpacketComponent = isPc() ? PCPacket : H5Packet;
  onMounted(() => {
    setTimeout(() => {
      props.sendRedpack && props.sendRedpack();
    }, 3000);
  });
  return {
    props,
    RedpacketComponent
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped></style>
